import { Component, inject, input, OnInit } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { SharedModule } from "../../shared.module";
import { Widget } from "../../../features/dashboard/models/dashboard.model";
import { DashboardFacadeService } from "../../../features/dashboard/services/dashboard-facade.service";
import { KtdGridModule } from "@katoid/angular-grid-layout";
import { RangePipe } from "../../pipes/range.pipe";
import { MatMenuModule } from "@angular/material/menu";

@Component({
  selector: "vl-widget-title",
  templateUrl: "./widget-title.component.html",
  styleUrls: ["./widget-title.component.scss"],
  standalone: true,
  imports: [MatIcon, MatTooltipModule, SharedModule, KtdGridModule, RangePipe, MatMenuModule],
})
export class WidgetTitleComponent implements OnInit {
  dashboardFacade = inject(DashboardFacadeService);

  text = input<string | number>();
  accent = input<string | number>();
  editable = input<boolean>(true);
  draggable = input(false);
  filter = input(false);
  widget = input<Widget>();
  /** Tooltip d'information sur le périmètre du widget — icône info à côté du titre. */
  info = input<string | null>(null);

  constructor() {}

  ngOnInit(): void {}

  onRemoveWidget() {
    this.dashboardFacade.removeWidget(this.widget());
  }

  setTheme(number: number) {
    this.dashboardFacade.updateWidget({ ...this.widget(), color: number });
  }
}
